import React from "react";
import "./deepInteriorCleaning.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
 
// adjust image path if needed

export default function DeepInteriorCleaning() {
  return (
    <>
    <Helmet>
      <title>Best Deep Interior Car Cleaning Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Experience a fresh and hygienic car interior with professional deep interior cleaning service at AutoCare in Palwal. We offer premium car repair & detailing solutions for complete interior restoration."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/interior-cleaning"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT CONTENT */}
        <div className="textContent">
          <h1>Best Deep Interior Car Cleaning Service in Palwal</h1>

          <p>
            Experience a fresh, hygienic, and odor-free car interior with
            <strong> professional deep interior cleaning service</strong> at
            <span className="highlight"> AutoCare</span>.
            We are a trusted <span className="highlight">Auto Care in Palwal</span>
            providing premium <strong>car repair & detailing solutions</strong>
            for complete interior restoration.
          </p>

          <h2>What is Deep Interior Car Cleaning?</h2>
          <p>
            Deep interior cleaning is an advanced car detailing process that
            removes dust, stains, bacteria, and bad odors from seats, carpets,
            dashboard, roof lining, and air vents, giving your car a
            brand-new feel from inside.
          </p>

          <h2>Benefits of Deep Interior Cleaning</h2>
          <ul>
            <li>Removes stains, dust & hidden bacteria</li>
            <li>Eliminates bad odors & allergens</li>
            <li>Improves cabin hygiene & air quality</li>
            <li>Enhances interior look & comfort</li>
            <li>Increases resale value of your car</li>
          </ul>

          <h2>Why Choose AutoCare for Interior Cleaning?</h2>
          <ul>
            <li>One of the <span className="highlight">best deep interior cleaning services in Palwal</span></li>
            <li>Professional vacuuming & steam cleaning tools</li>
            <li>Safe, eco-friendly cleaning products</li>
            <li>Experienced interior detailing experts</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span> for car repair</li>
          </ul>

          <h2>Book Deep Interior Cleaning Near You</h2>
          <p>
            Looking for the <span className="highlight">best interior car cleaning near me</span>?
            Choose <strong>AutoCare</strong> for deep, safe, and professional
            interior detailing services.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Deep Interior Cleaning
            </Link>
          </button>
        </div>

        {/* IMAGE CONTENT */}
        <div className="imageContent">
          <img
            src="/carServiceImages/deep Interior Cleaning.webp"
            alt="Best Deep Interior Car Cleaning Service in Palwal by AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
